import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import {
  ColumnDetails,
  GetRowsRequest,
  GetSummaryResponse,
  SetFiltersRequest,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../grid/types/common';
import { GetPackagesResponse, GetRowsResponse } from '../types/packages-grid-responses';
import { Column, ColumnKeys, PackagesEndpointMethod } from '../types';
import { API_TYPE_PACKAGES } from '../../../webcomponents.constants';
import { ConsoleRequest, DataProviderType, FilterKeyMapper } from '../../../utils/request';
import { saveViewState } from '../../../utils/states.utils';

export class PackagesGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private endpoint = 'Packages';
  private cachedGetPackagesResponse?: GetPackagesResponse;
  private readonly allColumnDetails: {};
  public companyFilterDataProvider = API_TYPE_PACKAGES;
  private filterKeyMapper: FilterKeyMapper = {
    'company.name': 'company.id',
  };
  public readonly viewStateName = 'packages-packagesViewState';

  constructor(public dependencies: any, allColumnDetails: ColumnDetails<Column, ColumnKeys>[]) {
    super();
    this.allColumnDetails = allColumnDetails.reduce((acc, curr) => ({...acc, [curr.key]: curr}), {});
  }

  private async getPackages(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetPackagesResponse> {
    const payload = ConsoleRequest.mapGridRequestToPayload(
      request,
      this.dependencies.getTimezone(),
      this.filterKeyMapper
    );
    try {
      return await ConsoleRequest.createRequest<GetPackagesResponse>({
        dataProviderType: DataProviderType.CORE,
        payload,
        endpoint: this.endpoint,
        method: PackagesEndpointMethod.READ_RECORDS,
      });
    } catch (error: any) {
      console.error(error);
      return {
        total: 0,
        data: [],
      };
    }
  }

  async getSummary(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetSummaryResponse> {
    this.cachedGetPackagesResponse = await this.getPackages(request);

    return {
      summary: '',
      numItems: this.cachedGetPackagesResponse.total,
    };
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetRowsResponse> {
    if (!this.cachedGetPackagesResponse) {
      this.cachedGetPackagesResponse = await this.getPackages(request);
      console.error('no cached Packages readRecords response');
    }

    return {
      success: true,
      rawEvents: this.cachedGetPackagesResponse.data,
    };
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    saveViewState(request, this.viewStateName);
    return;
  }

  async updateSettings(request: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    saveViewState(request, this.viewStateName);
    return {};
  }

  shouldDataReloadOnResetView(): boolean {
    return true;
  }
}
